import { RenderInput } from "../../hugo/gpu"
import { ENTITY_WIDTH } from "./constants"
import { Entity, GameField, Position2D, Rectangle } from "./types"

export const getLeft = (x: number, y: number, input: GameField | RenderInput) => {
    if (!input[y]) return
    return (input[y][x-1])
}

export const getRight = (x: number, y: number, input: GameField | RenderInput) => {
    if (!input[y]) return
    return (input[y][x+1])
}

export const getTop = (x: number, y: number, input: GameField | RenderInput) => {
    if (!input[y-1]) return
    return (input[y-1][x])
}
export const getBottom = (x: number, y: number, input: GameField | RenderInput) => {
    if (!input[y+1]) return
    return (input[y+1][x])
}

export const getAt = (x: number, y: number, input: GameField | RenderInput) => {
    if (!input[y]) return
    return (input[y][x])
}

export const inRange = (x: number, y: number, xr: number, yr: number, closure: (tx: number, ty: number) => void) => {
    for (let ty = y - yr; ty <= x +3; ty++) {
        for (let tx = x - xr; tx <= x +3; tx++) {
            closure(tx, ty)
        }
    }
}

export const detectCollisionBox = (box: Rectangle, field: GameField): Position2D | false => {
    for (let y = box.y1; y <= box.y2; y++) {
        for (let x = box.x1; x <= box.x2; x++) {
            if (field[y] && typeof field[y][x] !== 'undefined' && field[y][x] !== Entity.Empty) {
                return { x, y }
            }
        }
    }

    return false
}

export const detectCollision = (position: Position2D, field: GameField): false | Entity => {
    if (field[position.y] && typeof field[position.y][position.x] !== 'undefined') {
        return field[position.y][position.x] !== Entity.Empty ? field[position.y][position.x] : false
    }
    return false
}

export const rotateVector = (vec: Position2D, ang: number): Position2D => {
    ang = -ang * (Math.PI/180);
    var cos = Math.cos(ang);
    var sin = Math.sin(ang);
    return {
        x: Math.round(10000*(vec.x * cos - vec.y * sin))/10000,
        y: Math.round(10000*(vec.x * sin + vec.y * cos))/10000
    }
};


export const buildLevel = (reducedField: Entity[][], border: Entity = Entity.Wall) => {
    const field: Entity[][] = []
    reducedField.forEach((row, y) => {
        if (!Array.isArray(field[y])) field[y] = [border]
        row.forEach((entity: Entity, x) => {
            for(let i = 0; i < ENTITY_WIDTH; i ++) {
                field[y].push(entity)
            }
        })
    })
    for (let fillY = 0; fillY < 14; fillY ++) {
        if (!Array.isArray(field[fillY])) field[fillY] = [border]
        if (field[fillY].length  < 33) {
            field[fillY] = [...field[fillY], ...(new Array(33 - field[fillY].length).fill(Entity.Empty))]
        }
        field[fillY].push(border)
    }
    field.unshift((new Array(34)).fill(border))
    return field
}